import React, { useMemo } from 'react';
import { Chip } from '@mui/material';
import { useGetWorkflowTriggersQuery } from '../../../../../services/WorkflowService';

interface WorkflowTriggerBadgeProps {
  trigger: string;
}

const getTriggerColor = (trigger: string): string => {
  switch (trigger) {
    case 'TICKET_CREATED': return '#3b82f6';
    case 'STATUS_CHANGED': return '#8b5cf6';
    case 'PRIORITY_CHANGED': return '#ef4444';
    case 'ASSIGNMENT_CHANGED': return '#f59e0b';
    case 'COMMENT_ADDED': return '#10b981';
    case 'DUE_DATE_APPROACHING': return '#f97316';
    case 'MANUAL': return '#64748b';
    default: return '#64748b';
  }
};

const WorkflowTriggerBadge: React.FC<WorkflowTriggerBadgeProps> = ({ trigger }) => {
  const { data: workflowTriggers = [] } = useGetWorkflowTriggersQuery();
  const triggerLabel = useMemo(() => {
    const item = workflowTriggers.find(t => t.value === trigger);
    return item?.name || trigger;
  }, [workflowTriggers, trigger]);

  const color = getTriggerColor(trigger);

  return (
    <Chip
      label={triggerLabel}
      size="small"
      sx={{
        backgroundColor: `${color}15`,
        color,
        fontWeight: 600,
        fontSize: '0.75rem',
        height: '24px',
        border: `1px solid ${color}30`,
      }}
    />
  );
};

export default WorkflowTriggerBadge;
